// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form p[data-v-aa75d93a]{font-size:14px}form p[data-v-aa75d93a]:not(.error--text){color:#555}", ""]);
// Exports
module.exports = exports;
